import SettingsTab from './SettingsTab.vue';
export default SettingsTab;
